module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":"Public bond issue"},"title":"Public bond issue 2023"},"lt":{"meta":{"title":"Viešas obligacijų platinimas"},"title":"Viešas obligacijų platinimas 2023"}}')
  delete Component.options._Ctor
}
